module.exports = __webpack_public_path__ + "b8f3bd588c6c3c74d758b54b7adac038.png";